import React from 'react';
import { Button, Icon, IconNames } from '@dotcom/crown-ui';
import classNames from 'classnames';
import styles from './play-animation-button.module.scss';

export type PlayAnimationButtonProps = {
  label: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  /** Shows the Crown spinner and blocks input while the card animation is still being prepared. */
  isPreparing?: boolean;
};

/**
 * Shared "Play Animation" trigger.
 *
 * The editor quick preview uses it today. The preview view and the eCard send
 * view still render their own copies and are expected to adopt this component
 * so the three stay visually and behaviourally in sync.
 */
export const PlayAnimationButton = ({
  label,
  onClick,
  className,
  disabled = false,
  isPreparing = false,
}: PlayAnimationButtonProps) => (
  <Button
    testId="play-animation-button"
    className={classNames(styles['play-animation-button'], className)}
    aria-busy={isPreparing}
    disabled={disabled}
    loading={isPreparing}
    onClick={onClick}
    variant="secondary"
  >
    <Icon name={IconNames.PlaysmallBold} />
    {label}
  </Button>
);
